import { SVGProps } from "react";
import { useTheme } from "styled-components";

interface GhostIconProps extends SVGProps<SVGSVGElement> {
  fillColor: string;
}

const GhostIconContent = ({ fillColor, ...props }: GhostIconProps) => (
  <svg
    width={props.width ?? "24"}
    height={props.height ?? "24"}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.375 12.3748C9.99632 12.3748 10.5 11.8711 10.5 11.2498C10.5 10.6284 9.99632 10.1248 9.375 10.1248C8.75368 10.1248 8.25 10.6284 8.25 11.2498C8.25 11.8711 8.75368 12.3748 9.375 12.3748Z"
      fill={fillColor}
    />
    <path
      d="M14.625 12.3748C15.2463 12.3748 15.75 11.8711 15.75 11.2498C15.75 10.6284 15.2463 10.1248 14.625 10.1248C14.0037 10.1248 13.5 10.6284 13.5 11.2498C13.5 11.8711 14.0037 12.3748 14.625 12.3748Z"
      fill={fillColor}
    />
    <path
      d="M19.6504 11.6248C19.6504 9.59585 18.8438 7.65023 17.4092 6.21558C15.9745 4.78092 14.0289 3.97437 12 3.97437C9.97109 3.97437 8.02547 4.78092 6.59082 6.21558C5.15617 7.65023 4.34961 9.59585 4.34961 11.6248V19.3591L6.12012 17.9109L6.20703 17.8513C6.41891 17.7327 6.68651 17.7518 6.87988 17.9099L9.25 19.8494L11.6201 17.9109L11.707 17.8513C11.919 17.7325 12.1864 17.7526 12.3799 17.9109L14.749 19.8494L17.1201 17.9099C17.3411 17.7291 17.6589 17.7301 17.8799 17.9109L19.6504 19.3591V11.6248ZM20.8496 20.6248C20.8496 20.8566 20.7163 21.0675 20.5068 21.1667C20.2973 21.266 20.0495 21.2354 19.8701 21.0886L17.5 19.1492L15.1299 21.0896C14.9089 21.2704 14.5911 21.2695 14.3701 21.0886L12 19.1492L9.62988 21.0886C9.40889 21.2695 9.09115 21.2704 8.87012 21.0896L6.49902 19.1492L4.12988 21.0886C3.95046 21.2354 3.70267 21.266 3.49316 21.1667C3.28366 21.0675 3.15039 20.8566 3.15039 20.6248V11.6248C3.15039 9.27759 4.08249 7.02664 5.74219 5.36694C7.40188 3.70725 9.65283 2.77515 12 2.77515C14.3472 2.77515 16.5981 3.70725 18.2578 5.36694C19.9175 7.02664 20.8496 9.27759 20.8496 11.6248V20.6248Z"
      fill={fillColor}
    />
  </svg>
);

export const GhostIcon = ({
  size,
  fillColor,
}: {
  size?: number;
  fillColor?: string;
}) => {
  const theme = useTheme();
  return (
    <GhostIconContent
      width={size}
      height={size}
      fillColor={fillColor ?? theme.colorTextMain}
    />
  );
};
